import type { RandomSpaceAccessPublicConfig } from "./HomeModel";
import { MOCK_KNOWN_SPACES } from "../../global/GlobalMock";

export function mockCheckSpaceExists(spaceId: string): boolean {
  return /^\d{8}$/.test(spaceId) && spaceId in MOCK_KNOWN_SPACES;
}

const CACHE_KEY = "longfans.randomSpaceAccessConfigV1";
const CACHE_TTL_MS = 5 * 60 * 1000;

let memoryCache: { fetchedAt: number; config: RandomSpaceAccessPublicConfig } | null = null;

function readStorageCache(): { fetchedAt: number; config: RandomSpaceAccessPublicConfig } | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as { fetchedAt: number; config: RandomSpaceAccessPublicConfig };
    if (!parsed?.config || typeof parsed.fetchedAt !== "number") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function writeStorageCache(entry: { fetchedAt: number; config: RandomSpaceAccessPublicConfig }): void {
  memoryCache = entry;
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(entry));
  } catch {
    /* ignore quota */
  }
}

export function readRandomSpaceAccessCache(): RandomSpaceAccessPublicConfig | null {
  const now = Date.now();
  const cached = memoryCache ?? readStorageCache();
  if (!cached) {
    return null;
  }
  if (now - cached.fetchedAt > CACHE_TTL_MS) {
    return null;
  }
  memoryCache = cached;
  return cached.config;
}

export function writeRandomSpaceAccessCache(config: RandomSpaceAccessPublicConfig): void {
  writeStorageCache({ fetchedAt: Date.now(), config });
}

export const mockRandomSpaceAccessConfig: RandomSpaceAccessPublicConfig = {
  enabled: false,
  candidates: ["10000011", "10000012", "32230303"],
};
